import React from "react";
// eslint-disable-next-line import/no-extraneous-dependencies
import { get } from "lodash";
import { toKebabCase } from "@qlik/qlik/src/lib/utils";
import { mainMenu } from "@qlik/qlik/src/lib/menu";
import CardWithBorder from "@qlik/qlik/src/components/Header/Sub_Menu_Components/Card_With_Border";
import SubMenuWithIcon from "@qlik/qlik/src/components/Header/Sub_Menu_Components/Sub_Menu_with_Icon";
import * as styles from "./styles.module.css";

/**
 * SubmenuLayoutTwo renders the right hand side of a main menu drop down, with
 * left: CardWithBorder and right: one or more SubMenuWithIcon
 */
const SubmenuLayoutTwo = ({ data: subItems, layoutType, layoutId, className = "", deviceType = "desktop" }) => {
    const allowedLayoutMap = get(mainMenu, `[${layoutType}]`);
    const allowedComponents = Object.keys(allowedLayoutMap);
    const layoutClass = toKebabCase(layoutType);

    return (
        <div
            className={`submenu-level-3 ${className} flex-col xl:flex-row xl:gap-15 xl:py-14.75 relative`}
            data-parent={`${layoutClass}-${layoutId}`}
            data-device={`${deviceType}`}
        >
            <div className="-z-1 absolute max-xl:hidden bg-dropdownImage bg-contain -bottom-[344px] -right-291.25 w-455 h-97.75" />
            <div className="max-xl:mb-15 xl:flex-[0_0_375px]">
                {subItems[0] && allowedComponents[0] && <CardWithBorder data={subItems[0]} />}
            </div>
            <div className="xl:flex-[0_0_375px]">
                {subItems?.[1]?.title && (
                    <p className="text-md font-bold leading-none mb-7.5 tracking-normal">{subItems?.[1]?.title}</p>
                )}
                {subItems[1] && allowedComponents[1] && (
                    <ul className={`submenu-level-3-child ${styles.submenuComponentFive} `}>
                        {subItems[1]?.subItems?.map((subItem) => (
                            <li key={subItem.id}>
                                <SubMenuWithIcon data={subItem} />
                            </li>
                        ))}
                    </ul>
                )}
            </div>
        </div>
    );
};

export default SubmenuLayoutTwo;
